// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { EmployeeListResponse } from "./types";

import * as employeeActions from "./employee.actions";

export function* getEmployee(
  action: ReturnType<typeof employeeActions.getEmployeeAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'umn-pic';
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: EmployeeListResponse = yield call(result.json.bind(result));
      yield put(employeeActions.getEmployeeAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(employeeActions.getEmployeeAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(employeeActions.getEmployeeAsync.failure(parsed));
  }
}

export default function* employeeSagaGetEmployee() {
  yield takeEvery(employeeActions.getEmployeeAsync.request, getEmployee);
}
